import { render, staticRenderFns } from "./HIPAAContact.vue?vue&type=template&id=09808f68&scoped=true"
import script from "./HIPAAContact.vue?vue&type=script&lang=js"
export * from "./HIPAAContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09808f68",
  null
  
)

export default component.exports